// import SocialIcons from "./SocialIcons";
import {Controller, useForm} from "react-hook-form";
import {checkPhoneCode, loginByPhone} from "../../api/customer";
import {useContext, useEffect, useRef, useState} from "react";
import Input from "react-phone-number-input/input";
import {GlobalContext, ReducerActionType} from "../../GlobalReducer";
import LoginTypeSwitch from "./LoginTypeSwitch";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {useNavigate} from "react-router-dom";
import OpenidBlock from "./OpenidBlock";
import isEmail from "validator/es/lib/isEmail";
import RegistrationByPhoneOnly from "./RegistrationByPhoneOnly";
import {CustomerInterface} from "../../interfaces/customer/CustomerInterface";
import useMetrika from "../../utils/useMetrika";

const BLOCK_PHONE = 'phone';

const BLOCK_CODE = 'code';

const BLOCK_REGISTER = 'register';

const RESEND_SECONDS = 120;

function str_pad_left(string: string, pad: string, length: number) {
    return (new Array(length + 1).join(pad) + string).slice(-length);
}

function LoginByPhone({setError, setLoading, setCustomer}: {
    setError: Function,
    setLoading: Function,
    setCustomer: Function
}) {

    const phoneInputRef = useRef<HTMLInputElement>(null);
    const codeInputRef = useRef<HTMLInputElement>(null);

    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const [blockType, setBlockType] = useState(BLOCK_PHONE);
    const [userId, setUserId] = useState(0);
    const [seconds, setSeconds] = useState(0)
    const [isSafari, setIsSafari] = useState(false);

    const {ymb} = useMetrika()

    const [temporaryCustomer, setTemporaryCustomer] = useState<CustomerInterface | null>(null);

    const [prettySeconds, setPrettySeconds] = useState('')

    const {control, register, getValues, formState: {errors, dirtyFields}} = useForm({
        mode: "onChange"
    });

    const navigate = useNavigate()


    useEffect(() => {
        const safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        setIsSafari(safari);
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
            const input = phoneInputRef.current?.querySelector('input');
            input?.focus();
        }, 100);

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        const timeoutId = window.setTimeout(() => {
            if (!seconds) {
                return
            }
            setSeconds(seconds - 1)

            const minutes = Math.floor(seconds / 60)
            const sec = seconds - minutes * 60;
            const finalTime = str_pad_left(minutes.toString(), '0', 2) + ':' + str_pad_left(sec.toString(), '0', 2);

            setPrettySeconds(finalTime)

        }, 1000)

        return () => window.clearTimeout(timeoutId)
    }, [seconds])

    useEffect(() => {
        if (getValues().code && getValues().code.length === 6) {
            sendCode()
        }
        // eslint-disable-next-line
    }, [getValues().code])

    const sendPhone = () => {
        setError('')
        setSeconds(RESEND_SECONDS)

        const fields = getValues()
        if (!fields.phone) {
            setError('Не указаны телефон')
            return
        }
        setLoading(true)

        ymb('get_code')

        loginByPhone(fields.phone).then(status => {
            setUserId(status.user.id)
            setBlockType(BLOCK_CODE)
            setTimeout(() => {
                const input = codeInputRef.current?.querySelector('input');
                input?.focus();
            }, 100);

        }).catch(error => {
            const errors = error.toJSON();
            if (errors.status === 401) {
                setError("Неверный логин или пароль")
                return
            }
            setError(error.response?.data?.detail || error.response?.data?.message)
        }).finally(() => {
            setLoading(false)
        })
    }

    const sendCode = () => {
        setError('')
        const fields = getValues()
        if (!fields.code) {
            setError('Не указан код')
            return
        }
        setLoading(true)

        ymb('send_code')

        checkPhoneCode(userId, fields.code).then(response => {
            if (!response.user.first_name && !response.user.last_name) {
                setTemporaryCustomer(response.user)
                setBlockType(BLOCK_REGISTER)
            } else {
                console.log('Next Action', state.nextAction)
                setCustomer(response.user)
                if (state.nextAction === 'goToCabinet') {
                    navigate('/personal-area/')
                }
                dispatch({type: ReducerActionType.CLOSE_ALL_POPUP})
                dispatch({type: ReducerActionType.SET_PARAM, paramName: 'nextAction', payload: ''})
            }
        }).catch(error => {
            const errors = error.toJSON();
            if (errors.status === 401) {
                setError("Неверный логин или пароль")
                return
            }
            setError(error.response?.data?.detail || error.response?.data?.message)
        }).finally(() => {
            setLoading(false)
        })
    }

    return (<>
            <h4 className="modal-form__title f-exp">Вход или регистрация</h4>
            <LoginTypeSwitch/>
            <div className="tab-content">
                <div className="tab-pane fade active show">
                    {blockType === BLOCK_PHONE &&
                        <div className={'text-muted'}>На указанный номер поступит СМС с кодом</div>}
                    {blockType === BLOCK_CODE &&
                        <div className={'text-muted'}>Мы отправили подтверждение на номер </div>}

                    {blockType === BLOCK_PHONE && <>
                        <form onSubmit={(e) => {
                            e.preventDefault();
                        }}>
                            <div className="form-group" ref={phoneInputRef}>
                                <label className="form-label">Номер телефона</label>
                                <Controller
                                    control={control}
                                    name="phone"
                                    rules={{
                                        required: true,
                                        validate: v => /^[+\d]{12,20}$/.test(v)
                                    }}
                                    render={({field: {onChange, name, value}}) => (
                                        <Input
                                            className={'form-control ' + (errors.phone ? ' is-invalid' : '')}
                                            placeholder="+7 ___ ___-__-__"
                                            name={name}
                                            onChange={(value) => {
                                                if(!value) return
                                                let val = value.replace(/\D/g, '');
                                                if (val.length > 0 && !val.startsWith('7')) {
                                                    if (val.startsWith('8')) {
                                                        val = '7' + val.slice(1);
                                                    } else {
                                                        val = '7' + val;
                                                    }
                                                }
                                                onChange(val ? '+' + val : '');
                                            }}
                                            value={value}
                                        />
                                    )}
                                />
                            </div>
                            <div className="form-btns">
                                <button type={'button'} className="btn btn-secondary" onClick={sendPhone}>Получить код
                                </button>
                            </div>
                            <OpenidBlock/>
                            <div className="form-foot">
                                <p>Нажимая кнопку “Отправить”, Вы соглашаетесь с <a href="/landing/26/">Политикой
                                    конфиденциальности</a> и <a
                                    href="/landing/27/">Политикой обработки cookies</a></p>
                            </div>
                        </form>
                    </>}
                    {blockType === BLOCK_CODE && <>
                        <form>
                            <div className="form-group" ref={codeInputRef}>
                                <label className="form-label">Код из СМС</label>
                                <input type='text'
                                       autoComplete={isSafari ? "off" : "one-time-code"}
                                       className={'form-control text-center form-control-lg ' + (errors.code ? ' is-invalid' : '')}
                                       placeholder="_ _ _ _ _ _" {...register("code", {required: true})}
                                       onInput={(e) => {
                                           // @ts-ignore
                                           const value = e.target.value;
                                           if (value.length === 6) { // предполагаем, что код 6 символов
                                               setTimeout(() => sendCode(), 100); // небольшая задержка для обработки
                                           }
                                       }}

                                />
                            </div>

                            {seconds > 0 &&
                                <div className={'text-muted text-center'}>Получить новый код можно
                                    через {prettySeconds}</div>}
                            {seconds <= 0 &&
                                <div className={'text-muted text-center'}><span className={'control'} onClick={() => {
                                    sendPhone()
                                }}>Отправить код повторно</span></div>}

                            <div className="form-btns mt-4">
                                <button type={'button'} className="btn btn-secondary" onClick={sendCode}>Войти</button>
                            </div>
                        </form>
                    </>}
                    {blockType === BLOCK_REGISTER && temporaryCustomer &&
                        <RegistrationByPhoneOnly customer={temporaryCustomer} setCustomer={setCustomer}
                                                 setError={setError} setLoading={setLoading}/>}
                    {blockType === BLOCK_REGISTER && !temporaryCustomer &&
                        <div className={'text-center text-danger'}>Проблемы с установкой временного пользователя. <br/>Мы
                            уже работаем над решением проблемы</div>}
                </div>

            </div>
        </>
    )
}

export default LoginByPhone